
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/[cat]/[subcat]/[subsubcat]",
      function () {
        return require("private-next-pages/archive/[cat]/[subcat]/[subsubcat]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/[cat]/[subcat]/[subsubcat]"])
      });
    }
  